import { BlockSchema } from './Block.types';

import { EmbedBlockConfigSchema } from './blockConfig/Types';

import { z } from 'zod';

export const EmbedBlockSchema = BlockSchema.extend({
  blockConfig: EmbedBlockConfigSchema,
});
export type EmbedBlock = z.infer<typeof EmbedBlockSchema>;
